/**
 * Badge component for displaying log levels with appropriate styling
 */

import { Badge } from '@/components/ui/badge';
import type { LogLevel } from '@/types/dashboard';

interface LogLevelBadgeProps {
  level: LogLevel | undefined;
}

/**
 * Renders a styled badge for log levels (INFO, WARN, ERROR)
 */
export function LogLevelBadge({ level }: LogLevelBadgeProps) {
  if (!level) {
    return (
      <Badge variant="outline" className="text-muted-foreground">
        LOG
      </Badge>
    );
  }

  switch (level) {
    case 'ERROR':
      return <Badge variant="destructive">ERROR</Badge>;

    case 'WARN':
      return (
        <Badge className="bg-yellow-500/15 text-yellow-600 border-yellow-500/30 dark:text-yellow-400">
          WARN
        </Badge>
      );

    case 'INFO':
      return (
        <Badge variant="secondary" className="text-muted-foreground">
          INFO
        </Badge>
      );

    default:
      return (
        <Badge variant="outline" className="text-muted-foreground">
          {level}
        </Badge>
      );
  }
}
